import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from 'axios'
const axios = require('axios');
const url = process.env.REACT_APP_URI
const companyId = process.env.REACT_APP_COMPANY_ID
const user = localStorage.getItem("userAccess");
const header = `Bearer ${user}`;

export const getUsers = createAsyncThunk(
    'ladatatest/getUsers',
    async (thunkAPI) => {
        const response = await axiosInstance.request({
            // url: `https://jsonplaceholder.typicode.com/users`,
            url: `https://dummyjson.com/users`,
            method: 'get'
        });
        return { data: response.data };
    }
);

export const downloadCertificate = createAsyncThunk(
    'attendees/downloadCertificate',
    async (args) => {
      const { attendeeId, eventId, name, format } = args;
      const response = await axiosInstance.request({
        url: `https://api.eventonline.mx/events/0ac1a2d0-f3c1-4f86-9831-3a5fddbefe96/attendees/${attendeeId}/certificate?`,
        method: 'get',
        headers: { Authorization: header },
        params: { format },
        responseType: 'blob'
      })
      const urlFile = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.setAttribute('href', urlFile);
      link.setAttribute('download', `${name}.${format}`);
      document.body.appendChild(link);
      link.click();
    }
  )

export const testSlice = createSlice({
    name: 'ladatatest',
    initialState: {
        list: []
    },
    reducers: {
     
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUsers.fulfilled, (state, action) => {
                state.list = action.payload.data
            })
            .addCase(getUsers.pending, (state, action) => {

            })
    }
})

export default testSlice.reducer